import {
  endOfDay,
  endOfMonth,
  startOfDay,
  startOfMonth,
  subDays,
  subHours,
  subMonths,
} from 'date-fns';
import type { HistoryPageFilter, OperationDto } from '@/shared/types';

const getDateRange = (
  filters: HistoryPageFilter
): { from?: Date; to?: Date } => {
  const now = new Date();

  switch (filters.datefilter) {
    case 'last24h':
      return { from: subHours(now, 24) };
    case 'last30d':
      return { from: subDays(now, 30) };
    case 'these3months':
      return { from: subMonths(now, 3) };
    case 'thismonth':
      return { from: startOfMonth(now) };
    case 'prevmonth': {
      const prev = subMonths(now, 1);
      return { from: startOfMonth(prev), to: endOfMonth(prev) };
    }
    case 'custom':
      return {
        from: filters.datefrom ? startOfDay(filters.datefrom) : undefined,
        to: filters.dateto ? endOfDay(filters.dateto) : undefined,
      };
    default:
      return {};
  }
};

export const filterOperations = (
  operations: OperationDto[],
  filters: HistoryPageFilter
): OperationDto[] => {
  const { from, to } = getDateRange(filters);

  return operations.filter(operation => {
    if (
      filters.filter !== 'all' &&
      operation.operationType !== filters.filter
    ) {
      return false;
    }

    const date = new Date(operation.date);
    if (from && date < from) return false;
    if (to && date > to) return false;

    return true;
  });
};
